import FeedbackSuccessLogin from '../../components/molecules/feedbacks/FeedbackSuccessLogin'
import FeedbackErrorLogin from '../../components/molecules/feedbacks/FeedbackErrorLogin'
import FeedbackSuccessLogout from '../../components/molecules/feedbacks/FeedbackSuccessLogout'

export default {
  components: {
    FeedbackSuccessLogin,
    FeedbackErrorLogin,
    FeedbackSuccessLogout
  }
}
